import { render } from "./EnergyTransitionRenewable.vue?vue&type=template&id=f35255f8&ts=true"
import script from "./EnergyTransitionRenewable.vue?vue&type=script&lang=ts"
export * from "./EnergyTransitionRenewable.vue?vue&type=script&lang=ts"

import "./EnergyTransitionRenewable.vue?vue&type=style&index=0&id=f35255f8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__